export interface Appender {
    consume(): void;
}

export function isAppender(
    /* eslint-disable  @typescript-eslint/no-explicit-any */ object: any /* eslint-enable  @typescript-eslint/no-explicit-any */
): object is Appender {
    return (<Appender>object).consume !== undefined;
}
